import type { AppSnapshot } from '../workbench-shared';

export interface WorkspaceDraft { account:string; id:string; savedAt:string; catalogVersion:string; baseSignature:string; value:AppSnapshot }
const database='minglun-local-drafts-v1';
let connection:Promise<IDBDatabase>|undefined;
function connect(){
  return connection??=new Promise<IDBDatabase>((resolve,reject)=>{
    const request=indexedDB.open(database,1);
    request.onupgradeneeded=()=>request.result.createObjectStore('drafts',{keyPath:'account'});
    request.onsuccess=()=>resolve(request.result);
    request.onerror=()=>{connection=undefined;reject(request.error);};
  });
}
export async function snapshotSignature(snapshot:AppSnapshot):Promise<string>{
  const encoded=new TextEncoder().encode(JSON.stringify(snapshot));
  const digest=await crypto.subtle.digest('SHA-256',encoded);
  return Array.from(new Uint8Array(digest),x=>x.toString(16).padStart(2,'0')).join('');
}
export async function readWorkspaceDraft(account:string):Promise<WorkspaceDraft|undefined>{
  const db=await connect();
  return new Promise((resolve,reject)=>{const request=db.transaction('drafts').objectStore('drafts').get(account);request.onsuccess=()=>{const value=request.result as WorkspaceDraft|undefined;resolve(value?.account===account?value:undefined);};request.onerror=()=>reject(request.error);});
}
export async function writeWorkspaceDraft(draft:WorkspaceDraft):Promise<void>{
  const db=await connect();
  return new Promise((resolve,reject)=>{const transaction=db.transaction('drafts','readwrite');transaction.objectStore('drafts').put(draft);transaction.oncomplete=()=>resolve();transaction.onerror=()=>reject(transaction.error);transaction.onabort=()=>reject(transaction.error??new Error('本地草稿事务中止'));});
}
export async function removeWorkspaceDraft(account:string,expectedId?:string):Promise<void>{
  const db=await connect();
  return new Promise((resolve,reject)=>{
    const transaction=db.transaction('drafts','readwrite'),store=transaction.objectStore('drafts');
    const request=store.get(account);
    request.onsuccess=()=>{if(!expectedId || request.result?.id===expectedId)store.delete(account);};
    transaction.oncomplete=()=>resolve();transaction.onerror=()=>reject(transaction.error);
  });
}
